// extracted by mini-css-extract-plugin
export default {"Container":"Main_Container__8ckQF","MarginBottom52":"Main_MarginBottom52__e3koi","MarginBottom150":"Main_MarginBottom150__ulGhv"};